import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username } from '../internal.js'

const credentialTypes = [password, username] as const

export type kidyCredType = (typeof credentialTypes)[number]

export const kidyDocumentTypes = [
  'proof-of-delivery',
] as const satisfies readonly DocumentType[]

export const kidy: CarrierDef<kidyCredType> = {
  name: 'Kindersley Transport',
  scac: 'kidy',
  credentialTypes,
  legacyCredMap: [
    ['password', 'password'],
    ['username', 'username'],
  ],
  engineLayers: ['documents'],
  documentTypes: kidyDocumentTypes,
}
